import {ListItemType} from 'hiya-common/src/reducers/commonTypes'

enum PageTypeEnum {
  Task = 1,
  Quiz = 2,
}
enum TaskTypeEnum {
  TaskList = 1,
  TaskRecord = 2,
  TaskLotteryLog = 3,
}
enum QuizTypeEnum {
  // 晋级队伍
  in = 1,
  // 淘汰队伍
  out = 2,
}
// 国家选择的
interface country_item {
  id: number
  name: string
  pic: string
  odds: number
}
interface bet_rank_item {
  id: number
  coins: number // 国家押注
  rank: number //	排名
  name: string // 国家名称
  pic: string //	国旗
  person_list: ListItemType[] // 押注人列表
  odds: number //	赔率
  my_coins: number //	我的押注
  my_win: number //	预期赢的金币
}
// 抽奖轮播
interface lottery_record {
  name: string //		用户昵称
  gift_name: string //		礼物名字
}
// 抽奖礼物信息
interface lottery_info {
  id: number //	奖品id
  desc: string //	奖品名称
  icon: string //	奖品图片
}
interface lottery_history {
  id: number //	奖品id
  icon: string //	奖品图片
  lt: string //	抽奖时间
}
interface invite_history {
  mid: number //	被邀请mid
  name: string //	被邀请mid 的名字
  desc: string //	邀请描述
  avartar: string //	被邀请mid头像
  st: string //	被邀请的时间
}
export {
  bet_rank_item,
  country_item,
  invite_history,
  lottery_history,
  lottery_info,
  lottery_record,
  PageTypeEnum,
  QuizTypeEnum,
  TaskTypeEnum,
}
